module.exports = __webpack_public_path__ + "peloton.svg?b9720f60f98785023566c4269a09e9b9";